import { render, staticRenderFns } from "./OptionsAtticContainer.vue?vue&type=template&id=90ef9d20"
import script from "./OptionsAtticContainer.vue?vue&type=script&lang=js"
export * from "./OptionsAtticContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports